import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/{id}/name', 'put'>;
type ResponseBody = OASOutput<O, '/api/projects/{id}/name', 'put'>;

type Params = {
  id: number;
  name: string;
};

type Result = {
  id: number;
  name: string;
};

export const renameProjectFactory = (apiClient: ApiClient) => {
  const renameProject = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/{id}/name'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        id: input.id,
      },
      json: {
        name: input.name,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      name: response.name,
    };
  };

  return renameProject;
};
